import { Button } from "@/components/ui/button";
import { ArrowRight, Shield, Clock, CheckCircle } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_med-transcribe-4/artifacts/hi10en9r_ChatGPT%20Image%20Feb%208%2C%202026%2C%2008_43_59%20PM.png";

const HeroSection = ({ onScheduleDemo, onContactUs }) => {
  const trustBadges = [
    { icon: Shield, text: "HIPAA Compliant" },
    { icon: Clock, text: "24hr Turnaround" },
    { icon: CheckCircle, text: "99.9% Accuracy" },
  ];

  return (
    <section 
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden"
    >
      {/* Background Elements */}
      <div className="absolute inset-0 grid-pattern opacity-50" />
      <div className="hero-glow animate-pulse-glow" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-20 text-center">
        {/* Logo Display */}
        <div className="mb-6 sm:mb-8 animate-fade-in-up">
          <img 
            src={LOGO_URL} 
            alt="MedinoteX" 
            className="h-16 sm:h-20 md:h-28 w-auto mx-auto"
          />
        </div>

        {/* Main Headline */}
        <h1 
          className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-4 sm:mb-6 animate-fade-in-up stagger-1 px-4"
          style={{ fontFamily: 'Manrope, sans-serif' }}
        >
          <span className="gradient-text">MediNoteX</span>
        </h1>

        {/* Tagline */}
        <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-cyan-400 font-medium mb-3 sm:mb-4 animate-fade-in-up stagger-2 px-4">
          Document Less. Care More.
        </p>

        {/* Supporting Line */}
        <p className="text-base sm:text-lg md:text-xl text-slate-400 max-w-2xl mx-auto mb-8 sm:mb-10 animate-fade-in-up stagger-3 px-4">
          Medical Documentation Support for Doctors & Healthcare Facilities
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-10 sm:mb-16 animate-fade-in-up stagger-4 px-4">
          <Button
            onClick={onContactUs}
            data-testid="hero-contact-btn"
            className="btn-secondary h-12 sm:h-14 px-6 sm:px-8 text-base sm:text-lg"
          >
            Contact Us
          </Button>
          <Button
            onClick={onScheduleDemo}
            data-testid="hero-demo-btn"
            className="btn-primary h-12 sm:h-14 px-6 sm:px-8 text-base sm:text-lg group"
          >
            Schedule a Demo
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-4 animate-fade-in-up stagger-5 px-4">
          {trustBadges.map((badge, index) => (
            <div 
              key={index}
              className="trust-badge text-xs sm:text-sm"
            >
              <badge.icon className="w-3 h-3 sm:w-4 sm:h-4 text-cyan-500" />
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0A0A0A] to-transparent pointer-events-none" />
    </section>
  );
};

export default HeroSection;
